import styled from "styled-components";
import { FC } from "react";
import { components } from "react-select";
import "./valueContainer.css";

import { SelectComponentProps } from "./types";

const StyledInnerContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  gap: 8px;
  width: 100%;
  height: 20px;
  /**
  * last children is always the input caret
  * we need to re-align it and center it vertically
  * due to the flex wrap of the parent
  **/
  & > *:last-child {
    position: absolute;
    margin-top: 2px;
    left: 0;
  }
`;

type ValueContainerProps = SelectComponentProps["ValueContainer"];

export const ValueContainer: FC<ValueContainerProps> = ({
  children,
  ...props
}) => {
  if (!props.isMulti)
    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );

  return (
    <components.ValueContainer
      {...props}
      className={
        props?.className
          ? props?.className + " react-select-value-container"
          : ""
      }
    >
      <StyledInnerContainer ref={props.selectProps.valueContainerChildRef}>
        {children}
      </StyledInnerContainer>
    </components.ValueContainer>
  );
};
